<template>
  <div class="application-steps-wrapper" v-bind="$attrs">
    <div class="application-steps" :style="{ bottom: stepScroll }">
      <slot></slot>
    </div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  stepScroll: string;
}

const props = withDefaults(defineProps<Props>(), {
  stepScroll: "1",
});

defineExpose({
  props,
});
</script>

<style lang="scss" scoped>
.application-steps-wrapper {
  position: relative;
  width: 65%;
  height: 100%;
  display: block;
  overflow: hidden;

  .application-step-header {
    width: calc(100% - 2em);
    text-align: right;
    .application-step-header-text {
      color: #868686;
    }
  }

  .application-steps {
    height: 100%;
    width: 100%;
    width: 100%;
    position: absolute;
    transition: bottom 1s ease;

    .application-steps-wrapper {
      width: 100%;
    }
  }
}

.application-steps-wrapper:is(.no-margins) {
  .application-steps {
    width: calc(100% - 0px) !important;
  }
}
@media (max-width: 500px) {
  .application-steps-wrapper .application-steps {
    width: 100%;
  }
}
</style>
